module.exports = __webpack_public_path__ + "static/media/LogoLoginHollo.50cbb622.svg";